import {
  init,
  loadRemote,
  registerRemotes,
} from '@module-federation/enhanced/runtime';
import { uuidv4 } from './functions';

type RemoteFunction = (...args: any[]) => any;

interface LoadAndExecuteOptions {
  remoteName: string;
  remoteUrl: string;
  moduleName: string;
  args?: any[];
}

function isManifestUrlKnown(url: string): boolean {
  const manifest = (globalThis as any).__FEDERATION?.__MANIFEST_LOADING__ ?? {};

  const currentBase = window.location.origin;

  const normalize = (inputUrl: string): string => {
    try {
      const parsed = new URL(inputUrl, currentBase);
      return parsed.pathname;
    } catch {
      return inputUrl.split('?')[0].replace(/^(https?:\/\/)?[^/]+/, '');
    }
  };

  const targetPath = normalize(url);

  return Object.keys(manifest).some((key) => normalize(key) === targetPath);
}

export async function loadAndExecuteRemoteFunction({
  remoteName,
  remoteUrl,
  moduleName,
  args = [],
}: LoadAndExecuteOptions): Promise<any> {
  if (!(globalThis as any).singleton_federation_host) {
    (globalThis as any).singleton_federation_host = init({
      name: 'host_app',
      remotes: [],
    });
  }

  if (!isManifestUrlKnown(remoteUrl)) {
    registerRemotes([
      { name: remoteName, entry: remoteUrl + '?query=' + uuidv4() },
    ]);
  }

  // Load the remote container
  const container: { default: RemoteFunction } | null = await loadRemote(
    moduleName ? `${remoteName}/${moduleName}` : remoteName
  );

  const remoteFunction: RemoteFunction | undefined = container?.default;

  if (typeof remoteFunction !== 'function') {
    throw new Error(
      `Function not found in "${
        moduleName ? `${remoteName}/${moduleName}` : remoteName
      }"`
    );
  }

  return remoteFunction(...args);
}
